/* footer.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./footer.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@compiled/react';
import { FormattedMessage } from 'react-intl-next';
import { Flex, Inline } from '@atlaskit/primitives/compiled';
import { N40 } from '@atlaskit/theme/colors';
import { asyncPopupSelectMessages } from './messages';
var styles = {
  footerContainerStyles: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _uwhke4h9 _15a5nqa1 _1i53b5v6",
  footerPaginationInfoStyles: "_syaz1rpy"
};
var PopupFooter = function PopupFooter(_ref) {
  var currentDisplayCount = _ref.currentDisplayCount,
    totalCount = _ref.totalCount,
    filterName = _ref.filterName;
  return /*#__PURE__*/React.createElement(Flex, {
    testId: "".concat(filterName, "--footer"),
    direction: "row",
    alignItems: "center",
    justifyContent: "end",
    xcss: cx(styles.footerContainerStyles)
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.footerPaginationInfoStyles)
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, asyncPopupSelectMessages.paginationDetails, {
    values: {
      currentDisplayCount: currentDisplayCount,
      totalCount: totalCount
    }
  }))));
};
export default PopupFooter;